import React from "react";
import LiveIcon from "../../assets/media/icons/live.svg";
import InactiveIcon from "../../assets/media/icons/inactive.svg";
import "./Status.css";
const Status = ({ onSwitchStatus, isLive, onEdit, dataTarget }) => {
  return (
    <div className="state-container">
      <div className="status" onClick={onSwitchStatus}>
        <img src={isLive ? LiveIcon : InactiveIcon} alt="icon" />
        {isLive ? "LIVE" : "INACTIVE"}
      </div>
      {dataTarget ? (
        <button
          type="button"
          className="btn btn-secondary"
          data-toggle="modal"
          data-target={dataTarget}
          onClick={onEdit}
        >
          Edit
        </button>
      ) : (
        <button type="button" className="btn btn-secondary" onClick={onEdit}>
          Edit
        </button>
      )}
    </div>
  );
};

export default Status;



// WEBPACK FOOTER //
// ./src/screens/TokensAndPots/Status.js